import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import LottieSticker from "../LottieSticker";

type Share2EarnBtnProps = {
    className?: string;
};

const Share2EarnBtn: React.FC<Share2EarnBtnProps> = ({ className }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return null;

    return (
        <div
            className={clsx(
                "rounded-[8px] flex items-center bg-AlphaOrange dark:bg-DarkAlphaOrange cursor-pointer",
                className
            )}
            style={{ height: 36, padding: "4px 7px" }}
            onClick={() => {
                navigate("/token-identify");
            }}
        >
            <LottieSticker lottieName="hand-coin-orange" className="w-5 h-5" />
            <span
                className="text-body4 font-Semibold text-brand_1 ml-[4px] h-[20px]"
                style={{
                    fontSize: "0.8125rem",
                    lineHeight: "22px",
                }}
            >
                {t("share_2_earn")}
            </span>
        </div>
    );
};

export default Share2EarnBtn;
